
import { Component, Vue } from 'vue-property-decorator'
import SuperUpClass from '@/components/pc/superUpClass.vue'

@Component({
  name: 'LivePage',
  components: {
    SuperUpClass
  },
})
export default class LivePage extends Vue {
}
